// PRIVATE DATA!
// DO NOT IMPORT THIS DIRECTLY IN YOUR PROJECT!
// IT CAN BE CHANGED AT ANY TIME
export default /\sChrome\/([\d.]+)\s(Mobile(\/[\d.]+)?\s)?Safari\/[\d.]+$/;
